<div class="wrapper">
  @for(step of steps; track step.id) {
  <div (click)="stepClick.emit(step.id)" class="step-wrapper" [class.step-wrapper--active]="activeStep() === step.id">
    <div class="step-order">{{ step.order }}</div>
    <p class="step-title">{{ step.title }}</p>
  </div>
  }
</div>
